import Application from "../../Application";
import Area, { IArea } from "../../core/areas/Area";
import { IRouter } from "../../runtime/Router";
import CreateAttachmentTypeInteractor from "../interactor/CreateAttachmentTypeInteractor";
import GetAllGenericAttachmentTypesInteractor from "../interactor/GetAllGenericAttachmentTypesInteractor";
import ShowAttachmentTypesInteractor from "../interactor/ShowAttachmentTypesInteractor";
import UpdateAttachmentTypeInteractor from "../interactor/UpdateAttachmentTypeInteractor";
import AttachmentTypePage from "../ui/pages/AttachmentTypePage";

export default class AttachmentTypeArea extends Area implements IArea {
  private application: Application;
  private router: IRouter;

  constructor({
    application,
    router
  }: {
    application: Application;
    router: IRouter;
  }) {
    super();
    this.application = application;
    this.router = router;
  }
  private registerModules() {
    const container = this.application.container;
    container.registerInteractor(
      "createAttachmentType",
      CreateAttachmentTypeInteractor
    );
    container.registerInteractor(
      "updateAttachmentType",
      UpdateAttachmentTypeInteractor
    );
    container.registerInteractor(
      "getAllGenericAttachmentTypes",
      GetAllGenericAttachmentTypesInteractor
    );
    container.registerInteractor(
      "showAttachmentTypes",
      ShowAttachmentTypesInteractor
    );
  }
  register(params: any) {
    this.registerModules();

    this.router.registerRoutes({
      path: "/attachment-type",
      page: this.createPage({
        Page: AttachmentTypePage,
        action: this.showAttachmentTypePage.bind(this)
      }),
      options: {
        secure: false
      }
    });
  }

  public showAttachmentTypePage() {
    return this.application.container
      .resolve<ShowAttachmentTypesInteractor>("showAttachmentTypes")
      .execute();
  }
}
